import { angular2react } from 'angular2react'
import { lazyInjector } from './lazyInjector'
import ngMain from './ng-main.js';

export default angular2react('prMain', ngMain, lazyInjector.$injector);
